import OPathPanelOtgMobile from './o-path-panel-otg-mobile.vue';

export default OPathPanelOtgMobile;